import axios from "axios";
import store from "./store";

const api = axios.create({
    baseURL: "/api",
    timeout: 10000,
});

api.interceptors.request.use(
    config => {
        const token = store.getState().AuthReducer.token;
        if (token) {
            config.headers.auth = token;
        }
        return config;
    },
    error => Promise.reject(error)
);

api.interceptors.response.use(
    response => response,
    error => {
        const { response } = error;
        if (!response) {
            alert("서버에 연결할 수 없습니다.");
            return Promise.reject(error);
        }

        const { status, data } = response;
        if (status === 401 && data?.code === "TOKEN_EXPIRED") {
            alert("로그인 시간이 만료되었습니다.");

            store.dispatch({ type: 'logout' });

            window.location.replace("/login");
            return Promise.reject("TOKEN_EXPIRED");
        }

        if (status === 401) {
            store.dispatch({ type: 'logout' });
            window.location.replace("/login");
            return Promise.reject("UNAUTHORIZED");
        }
        
        return Promise.reject(error);
    }
);

export default api;
